import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/errors/notFound.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/vendor/[name]/[id]/vendorDetails.module.scss");
